'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTitle = setTitle;
exports.resetTitle = resetTitle;
exports.withDocumentTitle = withDocumentTitle;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setTitle(title) {
  document.title = _I18n2.default.text('pricingPage.windowTitles.' + title);
}

function resetTitle() {
  setTitle('default');
}

function withDocumentTitle(WrappedComponent, title) {
  return function (props) {
    (0, _react.useEffect)(function () {
      setTitle(title);

      return function () {
        return resetTitle();
      };
    }, []);

    return _react2.default.createElement(WrappedComponent, props);
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/utils/DocumentUtils.js
// module id = 125
// module chunks = 3 4